import { Popup } from '@fluentui/react';
import { colorPallet } from 'src/styles/theme/colors';
import styled from 'styled-components';
import { css } from 'styled-components';

const sharedStyle = css`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;
export const MobileCalendarContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 1rem;
`;

export const MobileCalendarTable = styled.table`
  font-size: 1rem;
`;

export const MobileCalendarHeaderRow = styled.tr``;

export const MobileCalendarRow = styled.tr``;

export const MobileCalendarCell = styled.td<{
  disabled: boolean;
  currentUserVacations: boolean;
}>`
  padding: 0.4rem;
  padding-left: 0.525rem;
  padding-right: 0.525rem;
  text-align: center;
  border-radius: 0.5rem;
  span {
    color: ${({ disabled, theme, currentUserVacations }) => {
      if (disabled) {
        return theme.datePickerDisabledDates;
      } else if (currentUserVacations) {
        return colorPallet.white;
      } else {
        return theme.calendarDateColor;
      }
    }};
  }
  background: ${({ currentUserVacations, disabled }) =>
    currentUserVacations && !disabled ? colorPallet.richBlue : 'transparent'};
  position: relative;
`;

export const MobileCalendarDrawer = styled(Popup)`
  background: ${(props) => props.theme.popupOpacity};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;
  @media (max-width: 1072px) {
    zoom: 0.6;
  }
`;

export const MobileCalendarOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  transition: height 0.3s ease-in-out;
  background-color: white;
  z-index: 10;
  color: black;
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  background: ${(props) => props.theme.mainBackgorund};
`;

export const MobileCalendarOverlayHeader = styled.div`
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  font-size: 2rem;
  background: #e8ebfa;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  color: ${(props) => props.theme.textMainColor};
  background: ${(props) => props.theme.tableHeadColor};
`;

export const CurrentUserVacationStyled = styled.div`
  ${sharedStyle}
`;

export const VacationDate = styled.p`
  ${sharedStyle}
  font-weight: 600;
`;

export const TeamVacationList = styled.ul`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  width: 100%;
  overflow: auto;
  height: 50vh;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    font-size: 1.25rem;
    color: ${(props) => props.theme.textMainColor};
  }
`;

export const TeamVacationListItem = styled.div`
  div {
    display: inline-flex;
  }
  li {
    margin-left: 1rem;
    display: inline-block;
  }
`;
